<section class="form">
  <form [formGroup]="formTable" class="form_table" (ngSubmit)="addData()">
    <!-- <div
      class=" input_table"
      data-text="Montos salvados *"
      [ngClass]="{ error: verificateInput('montos_salvados') }"
    >
      <input
        type="text"
        placeholder="Montos salvados"
        Currency
        formControlName="montos_salvados"
      /> 
     
    </div> -->
    <mat-form-field appearance="outline">
      <mat-label>Montos salvados</mat-label>
      <input formControlName="montos_salvados" matInput />
    </mat-form-field>
    <!-- <div
      class="style-input-default input_table"
      data-text="Datos del cliente *"
      [ngClass]="{ error: verificateInput('datos_cliente') }"
    >
      <input
        type="text"
        placeholder="Datos del cliente"
        formControlName="datos_cliente"
      />
    </div> -->
    <mat-form-field appearance="outline">
      <mat-label>Datos del cliente</mat-label>
      <input formControlName="datos_cliente" matInput />
    </mat-form-field>
    <!-- <div
      class="style-input-default input_table"
      data-text="Cuenta bancaria *"
      [ngClass]="{ error: verificateInput('cuenta_bancaria') }"
    >
      <input
        
        placeholder="Cuenta bancaria"
        onlyNumber
        formControlName="cuenta_bancaria"
      />
    </div> -->
    <mat-form-field appearance="outline">
      <mat-label>Cuenta bancaria</mat-label>
      <input formControlName="cuenta_bancaria" matInput />
    </mat-form-field>
    <!-- <div
      class="style-input-default input_table"
      data-text="Producto afectado *"
      [ngClass]="{ error: verificateInput('producto_afectado') }"
    >
      <input
        type="text"
        onlyNumber
        placeholder="Cuenta destino"
        formControlName="producto_afectado"
      />
    </div> -->
    <mat-form-field appearance="outline">
      <mat-label>Cuenta destino</mat-label>
      <input formControlName="producto_afectado" matInput />
    </mat-form-field>
    <!-- <div
      class="style-input-default input_table"
      data-text="Monto reclamado *"
      [ngClass]="{ error: verificateInput('monto_reclamado') }"
    >
      <input
        type="text"
        placeholder="Monto reclamado"
        Currency
        formControlName="monto_reclamado"
      />
    </div> -->
    <mat-form-field appearance="outline">
      <mat-label>Monto reclamado</mat-label>
      <input formControlName="monto_reclamado" matInput />
    </mat-form-field>
    <!-- <div
      class="style-input-default input_table"
      data-text="Monto retenido *"
      [ngClass]="{ error: verificateInput('monto_retenido') }"
    >
      <input
        type="text"
        placeholder="Monto retenido"
        Currency
        formControlName="monto_retenido"
      />
    </div> -->
    <mat-form-field appearance="outline">
      <mat-label>Monto retenido</mat-label>
      <input formControlName="monto_retenido" matInput />
    </mat-form-field>
    <!-- <div
      class="style-input-default input_table"
      data-text="Monto recuperado *"
      [ngClass]="{ error: verificateInput('monto_recuperado') }"
    >
      <input
        type="text"
        placeholder="Monto recuperado"
        Currency
        formControlName="monto_recuperado"
      />
    </div> -->
    <mat-form-field appearance="outline">
      <mat-label>Monto recuperado</mat-label>
      <input formControlName="monto_recuperado" matInput />
    </mat-form-field>
    <button
      type="submit"
      *ngIf="!status"
      [disabled]="formTable.invalid || submit"
      style="width: 100%"
    >
      Aceptar
    </button>
  </form>
</section>

<div class="task_content_table">
  <table mat-table #dataTable [dataSource]="dataSource" class="task_table">
    <ng-container matColumnDef="montos_salvados">
      <th class="header-options" mat-header-cell *matHeaderCellDef>
        Montos salvados
      </th>
      <td mat-cell *matCellDef="let element">{{ element.montos_salvados }}</td>
    </ng-container>

    <ng-container matColumnDef="datos_cliente">
      <th class="header-options" mat-header-cell *matHeaderCellDef>
        Datos del cliente
      </th>
      <td mat-cell *matCellDef="let element">{{ element.datos_cliente }}</td>
    </ng-container>

    <ng-container matColumnDef="cuenta_bancaria">
      <th class="header-options" mat-header-cell *matHeaderCellDef>
        Cuenta bancaria
      </th>
      <td mat-cell *matCellDef="let element">{{ element.cuenta_bancaria }}</td>
    </ng-container>

    <ng-container matColumnDef="producto_afectado">
      <th class="header-options" mat-header-cell *matHeaderCellDef>
        Producto afectado
      </th>
      <td mat-cell *matCellDef="let element">
        {{ element.producto_afectado }}
      </td>
    </ng-container>

    <ng-container matColumnDef="monto_reclamado">
      <th class="header-options" mat-header-cell *matHeaderCellDef>
        Monto reclamado
      </th>
      <td mat-cell *matCellDef="let element">{{ element.monto_reclamado }}</td>
    </ng-container>

    <ng-container matColumnDef="monto_retenido">
      <th class="header-options" mat-header-cell *matHeaderCellDef>
        Monto retenido
      </th>
      <td mat-cell *matCellDef="let element">{{ element.monto_retenido }}</td>
    </ng-container>

    <ng-container matColumnDef="monto_recuperado">
      <th class="header-options" mat-header-cell *matHeaderCellDef>
        Monto recuperado
      </th>
      <td mat-cell *matCellDef="let element">{{ element.monto_recuperado }}</td>
    </ng-container>

    <ng-container matColumnDef="opciones">
      <th class="header-options" mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let element; let i = index">
        <div class="options">
          <button class="delete" (click)="removeData(i)">
            <i class="fas fa-times"></i>
          </button>
        </div>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>
</div>
<mat-paginator
  [pageSizeOptions]="[5, 10, 25, 50, 100]"
  [pageSize]="5"
  [showFirstLastButtons]
></mat-paginator>
